import { Routes } from '@angular/router';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';
import { AuthGuard } from './guards/keycloak.guard';
import { StatsComponent } from './pages/stats/stats.component';

export const routes: Routes = [
  {
    path: 'military',
    component: FullComponent,
    data: { portalType: 'military' },
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'patients',
        pathMatch: 'full',
      },
      {
        path: 'patients',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./pages/pages.routes').then((m) => m.PagesRoutes),
      },
      {
        path: 'new-patient',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./pages/pages.routes').then((m) => m.PagesRoutes),
      },
      {
        path: 'stats',
        canActivate: [AuthGuard],
        component: StatsComponent,
      },
      {
        path: ':ehrId' + '/dossier',
        loadChildren: () =>
          import('./pages/dossier/dossier.routes').then((m) => m.DossierRoutes),
      },
    ],
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: () =>
          import('./pages/authentication/authentication.routes').then(
            (m) => m.AuthenticationRoutes
          ),
      },
      {
        path: 'landingpage',
        loadChildren: () =>
          import('./pages/theme-pages/landingpage/landingpage.routes').then(
            (m) => m.LandingPageRoutes
          ),
      },
    ],
  },
  {
    path: 'civilian',
    component: FullComponent,
    data: { portalType: 'civilian' },
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'patients',
        pathMatch: 'full',
      },
      {
        path: 'patients',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./pages/pages.routes').then((m) => m.PagesRoutes),
      },
      {
        path: 'new-patient',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./pages/pages.routes').then((m) => m.PagesRoutes),
      },
      {
        path: 'stats',
        canActivate: [AuthGuard],
        component: StatsComponent,
      },
      {
        path: ':ehrId' + '/dossier',
        loadChildren: () =>
          import('./pages/dossier/dossier.routes').then((m) => m.DossierRoutes),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'authentication/error',
  },
];
